import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  Modal,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import AdditionalHistory from "./AdditionalHistory";
import HistoryIcon from "@mui/icons-material/History";
import Cookies from "js-cookie";
import axios from "axios";
import CustomeToaster from "../CustomComponents/CustomToaster";
import { navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import { AdditionalFeeReducerAction } from "../Store/AdditionalFee/AdditionalFeeReducer";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const AccrualRemark = (props) => {
  const userName = useSelector((state) => state.branch.userName);
  const remarkErrorStatus = useSelector(
    (state) => state.AdditionalFee.remarkErrorClear
  );
  const [open, setOpen] = useState(false);
  const [toasterOpen, setToasterOpen] = useState(false);
  const [severity, setSeverity] = useState("");
  const [content, setContent] = useState("");
  const [discardOpen, setDiscardOpen] = useState(props.discardOpen);
  const [openSaveConfirmation, setOpenSaveConfirmation] = useState(false);
  const [savedDialog, setSavedDialog] = useState(false);
  const girdVisible = props.girdVisible;
  const dispatch = useDispatch();

  const openSaveDialog = async(value) => {
    if (
      !props.reason ||
      !props.remark ||
      props.remark.length < 3 ||
      specialCharecters.includes(props.remark.charAt(0)) ||
      props.remark.length > 2000
    ) {
      !props.reason ? props.setReasonError(true) : props.setReasonError(false);
      if (!props.remark) {
        props.setFirstCharError(false);
        props.setMinLetterError(false);
        props.setLengthError(false);
        props.setRemarkError(true);
        return;
      } else {
        props.setRemarkError(false);
      }
      props.remark.length > 2000
        ? props.setLengthError(true)
        : props.setLengthError(false);
      !props.remark ? props.setRemarkError(true) : props.setRemarkError(false);
      props.remark.length < 3
        ? props.setMinLetterError(true)
        : props.setMinLetterError(false);
      specialCharecters.includes(props.remark.charAt(0))
        ? props.setFirstCharError(true)
        : props.setFirstCharError(false);
    } else {
      const isValid=  await validateDisbursementStatus();
      if(!isValid){
        setContent("Unable to proceed due to disbursement is in Requested/Partial Approval State");
        setSeverity("error");
        setToasterOpen(true);
      }else{
        props.setReasonError(false);
        props.setRemarkError(false);
        props.setMinLetterError(false);
        setOpenSaveConfirmation(value);
      }
    }
  };
  // const closeSaveDialog
  const handleOpen = () => setOpen(true);
  const handleHistoryDialog = () => {
    handleOpen(true);
  };
  const cancelHandleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      props.setDiscardOpen(false);
    }
  };
  const [saveOnDialogDisable, setSaveOnDialogDisable] = useState(false);
  const specialCharecters = '/[!@#$%^&*()_+-=[]{};:"\\|,.<>/?]+/`~';
  const validateAndsetRemark = (value) => {
    if (
      ("" !== value && specialCharecters.includes(value.charAt(0))) ||
      value.length > 2000 ||
      value.length < 3 ||
      !value
    ) {
      if (!value) {
        props.setFirstCharError(false);
        props.setMinLetterError(false);
        props.setLengthError(false);
        props.setRemarkError(true);
        return;
      } else {
        props.setRemarkError(false);
      }
      value.length > 2000
        ? props.setLengthError(true)
        : props.setLengthError(false);
      if (specialCharecters.includes(value.charAt(0))) {
        props.setRemark(value);
      }
      specialCharecters.includes(value.charAt(0))
        ? props.setFirstCharError(true)
        : props.setFirstCharError(false);
      value.length < 3
        ? props.setMinLetterError(true)
        : props.setMinLetterError(false);
      props.setRemark(value);
    } else {
      props.setFirstCharError(false);
      props.setLengthError(false);
      props.setRemarkError(false);
      props.setMinLetterError(false);
      props.setRemark(value);
    }
  };
  const [resonValue, setReasonValue] = useState([]);
  const [waiverReason, setWaiverReason] = useState([]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    height: "80%",
    p: 4,
    marginTop: "30px",
  };
  //shortcut keys
  const historyRef = useRef(null);
  const detailRef = useRef(null);
  const cancelRef = useRef(null);
  const cancelDiscardRef = useRef(null);
  const okRef = useRef(null);
  const yesRef = useRef(null);
  const saveRef = useRef(null);
  const yesDiscardRef = useRef(null);
  const [historyEnable, sethistoryEnable] = useState(true);
  const [history, setHistory] = useState(true);
  const getReasonFromShflApi = async () => {
    var dataMap = { apiCode: "FEE_REASONS_API", createdBy: userName };
    try {
      const response = await axios.post(
        "/additionalfee/getReasonFromLov",
        dataMap
      );
      if (response.data.status === 1) {
        setReasonBasedOnReasonType(response.data.reason_dtls);
      } else if (response.data.status === -1) {
        console.log("Data is not fetchable");
      } else {
        console.log("API Code is not present");
      }
    } catch {
      console.log("Network Error");
    }
  };
  const setReasonBasedOnReasonType = (reasonData) => {
    var accrualReason = [];
    var waiverReason = [];
    reasonData.forEach((mapData) => {
      if (mapData["reason_type"] === "MA") {
        accrualReason.push({
          value: mapData["reason_desc"],
          label: mapData["reason_desc"],
          text: mapData["reason_desc"],
          name: mapData["reason_code"],
        });
      } else if (mapData["reason_type"] === "MW") {
        waiverReason.push({
          value: mapData["reason_desc"],
          label: mapData["reason_desc"],
          text: mapData["reason_desc"],
          name: mapData["reason_code"],
        });
      }
    });
    setReasonValue(accrualReason);
    setWaiverReason(waiverReason);
  };
  useEffect(() => {
    getReasonFromShflApi();
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "accuralRemark",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "y" && yesDiscardRef.current) {
        yesDiscardRef.current.click();
      } else if (charCode === "q" && cancelDiscardRef.current) {
        cancelDiscardRef.current.click();
      } else {
        let refList = {
          historyRef: !historyRef.current.disabled ? historyRef : null,
          okRef: okRef,
          saveRef: !saveRef.current.disabled ? saveRef : null,
          clearRef: props.clearRef,
          searchButtonRef: props.searchButtonRef,
          cancelRef: cancelRef,
          yesDiscardRef: yesDiscardRef.current ? yesDiscardRef : null,
          yesRef: yesRef.current ? yesRef : null,
        };
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "accuralRemark",
          })
        );
      }
    } else if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      if (savedDialog) {
        window.location.reload();
      }
      setSavedDialog(false);
      setOpenSaveConfirmation(false);
    } else {
      // event.preventDefault();
    }
  };

  //Snackbar close passed to component
  const closeSnackbar = () => {
    setToasterOpen(false);
  };

  //validation Unable to proceed due to disbursement is in Requested/Partial Approval State
  const validateDisbursementStatus = async() =>{
    const params = {
      "applicationNumber":[props.applicationNum]
      }
    try {
      let data;
      const response = await axios.post(
        "disbursement/validateDisbursementStatus",
        params
      );
      if (response.data) {
        data = response.data
      }
      return data;
    } catch(error) {
      setContent(error.message);
      setSeverity("error");
      setToasterOpen(true);
      throw new Error("Network error")
    }
  }
  
  //save data
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick" && "escapeKeyDown") return;
    setOpen(false);
  };
  const [cancelOpen, cancelSetOpen] = React.useState(false);
  // const handleCloseSaveDialog = () => setOpenSaveConfirmation(false);
  const saveAccrualDetails = async () => {
    if (!saveOnDialogDisable) {
      const isValid=  await validateDisbursementStatus()
      setSaveOnDialogDisable(true);
      if (
        !props.reason ||
        !props.remark ||
        props.remark.length < 3 ||
        specialCharecters.includes(props.remark.charAt(0))
      ) {
        if (!props.remark) {
          props.setFirstCharError(false);
          props.setMinLetterError(false);
          props.setLengthError(false);
          props.setRemarkError(true);
          return;
        } else {
          props.setRemarkError(false);
        }
        !props.reason
          ? props.setReasonError(true)
          : props.setReasonError(false);
        !props.remark
          ? props.setRemarkError(true)
          : props.setRemarkError(false);
        props.remark.length < 3
          ? props.setMinLetterError(true)
          : props.setMinLetterError(false);
        specialCharecters.includes(props.remark.charAt(0))
          ? props.setFirstCharError(true)
          : props.setFirstCharError(false);
      } else {
        props.setReasonError(false);
        props.setMinLetterError(false);
        // get the branch code based on the branch name.
        const branchNamesWithCodes = GetBranchDetailsWithCode();
        const branchCodeValue = branchNamesWithCodes.find((branch) => {
          return branch.label === props.branchName.label;
        });
        const dataMap = {};
        dataMap["branch"] = props.branchName.label;
        dataMap["branchCode"] = branchCodeValue.code;
        dataMap["gridData"] = props.gridData;
        dataMap["reason"] = props.reason;
        dataMap["remarks"] = props.remark;
        dataMap["refDate"] = props.refDate;
        dataMap["referenceNumber"] = props.refNum;
        dataMap["updatedBy"] = userName;
        dataMap["applicationNum"] = props.applicationNum;
        dataMap["type"] = props.type;
        dataMap["historyData"] = props.historyData;
        dataMap["codeMap"] = props.codeMap;

        try {
          const response = await axios.post(
            "/additionalfee/saveFeeDetails",
            dataMap
          );
          if (response.data === "saved") {
            setSavedDialog(true);
            setOpenSaveConfirmation(false);
            setSaveOnDialogDisable(false);
            // window.location.reload();
          }
        } catch {
          setContent("Network Error");
          setSeverity("error");
          setToasterOpen(true);
          console.log("Network Error");
        }
      }
    }
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          width: "calc(100% - 2px)",
          margin: "unset",
          backgroundColor: "#fff",
          marginTop: "4px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            marginTop: "-8px",
            marginLeft: "16px",
            height: "80%",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <CustomDropDown
                id="1"
                label="Reason "
                value={props.reason}
                defaultValue="1"
                required={true}
                dropDownValue={
                  props.name === "Accrued By" ? resonValue : waiverReason
                }
                variant="standard"
                onChange={(event) => {
                  props.setReason(event.target.value);
                  props.setReasonError(false);
                }}
              />
              {props.reasonError && remarkErrorStatus && (
                <p className="error">Please Select a Reason</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <CustomTextField
                required={false}
                disabled={true}
                label={props.name}
                id="refdate"
                value={userName}
                type="text"
                placeholder={props.name}
                variant="standard"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <InputLabel
                id="accrual-waiver-remark"
                sx={{
                  color: "#004A92",
                  marginTop: "8px",
                  fontWeight: 400,
                  fontSize: "0.875rem",
                }}
                required={true}
              >
                Remarks
              </InputLabel>
              <TextareaAutosize
                id="accrual-textarea"
                maxRows={4}
                required={true}
                value={props.remark}
                aria-label="maximum height"
                onBlur={(event) => validateAndsetRemark(event.target.value)}
                onChange={(event) => props.setRemark(event.target.value)}
                style={{
                  width: "100%",
                  height: "100px",
                  borderRadius: "4px",
                  resize: "none",
                  outline: "none",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                }}
              />
              {props.firstCharError && (
                <p className="error">
                  The 1st letter should not be a Special Character
                </p>
              )}
              {props.lengthError && (
                <p className="error">
                  Value is too long. Input less than 2000 characters.
                </p>
              )}
              {props.minLetterError && (
                <p className="error">
                  You Should Enter Atleast Three Characters
                </p>
              )}
              {props.remarkError && (
                <p className="error">Please Enter Remarks</p>
              )}
            </Grid>
          </Grid>
          <div style={{ padding: "8px", direction: "rtl" }}>
            <Tooltip title="Ctrl+H" placement="top">
              <Button
                onClick={handleHistoryDialog}
                variant="contained"
                ref={historyRef}
                sx={{
                  marginLeft: "8px",
                  marginRight: "8px",
                  color: "white",
                  backgroundColor: "black",
                  fontWeight: "bold",
                  height: "2rem",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
              >
                <HistoryIcon></HistoryIcon>
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+S" placement="top">
              <Button
                disabled={props.updateDisable}
                variant="contained"
                onClick={() => openSaveDialog(true)}
                ref={saveRef}
                sx={{ fontWeight: "bold", height: "2rem" }}
              >
                Update
              </Button>
            </Tooltip>
            <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
              <Modal
                sx={{
                  "& div.css-15edzf2": {
                    width: { xs: "90%", md: "80%", lg: "60%" },
                  },
                }}
                open={open}
                onClose={(event, reason) => handleClose(event, reason)}
                disableBackdropClick
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <AdditionalHistory
                    onClose={handleClose}
                    applicationNum={props.applicationNum}
                    feeType={props.type}
                  />
                </Box>
              </Modal>
            </Grid>
            <CustomeToaster
              severity={severity}
              open={toasterOpen}
              content={content}
              close={closeSnackbar}
            ></CustomeToaster>
          </div>
        </Box>
      </Grid>
      <Dialog
        open={openSaveConfirmation}
        // onClose={openSaveDialog(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {" "}
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              sx={{ fontWeight: "bold" }}
              ref={cancelRef}
              onClick={() => setOpenSaveConfirmation(false)}
            >
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              disabled={saveOnDialogDisable}
              sx={{ fontWeight: "bold" }}
              ref={yesRef}
              onClick={saveAccrualDetails}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        aria-describedby="alert-dialog-slide-description"
        open={props.discardOpen}
        onClose={cancelHandleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {"Are you sure want to discard changes ?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button
              onClick={cancelHandleClose}
              ref={cancelDiscardRef}
              sx={{ fontWeight: "bold" }}
              autoFocus
            >
              Cancel
            </Button>
          </Tooltip>

          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              onClick={props.discardChanges}
              ref={yesDiscardRef}
              sx={{ fontWeight: "bold" }}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        dialogOpen={savedDialog}
        onDialogClose={() => {
          window.location.reload();
        }}
        dialogTitle={
          <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
        }
        dialogContent={
          props.type === "waiver"
            ? "Updated Waiver Details Successfully."
            : "Updated Accrual Details Successfully."
        }
        hideCancelButton={true}
        okButtonName={"OK"}
        onOkClick={() => {
          window.location.reload();
        }}
      />
    </>
  );
};
export default AccrualRemark;
